module.exports = __webpack_public_path__ + "static/media/momPhoto.e3c6b9db.jpeg";